import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DashboardLogsStatusModule } from '../../shared/dashboard-logs-status/dashboard-logs-status.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { StaffRoutingModule } from './staff-routing.module';

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, StaffRoutingModule, DashboardLogsStatusModule],
})
export class StaffModule {}
